import { render, staticRenderFns } from "./agedTrialBalance.vue?vue&type=template&id=cffad640&"
import script from "./agedTrialBalance.vue?vue&type=script&lang=js&"
export * from "./agedTrialBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports